// extracted by mini-css-extract-plugin
module.exports = {"Card":"SystemStatus_Card__1WBVH","CardContainer":"SystemStatus_CardContainer__2yGr-"};